<div>
  <div *ngIf="hasTitle" class="title">Магазины</div>
  <ui-address-suggestions-select
    (changeAddress)="onChangeAddress($event)"
    [label]="suggestionSelectLabel"
  ></ui-address-suggestions-select>
  <div
    class="map-wrapper"
    [ngClass]="{ 'wrapper-error': !!error }"
    [ngbTooltip]="errorMessage"
    tooltipClass="error-tooltip"
    [autoClose]="false"
    triggers="manual"
    #errorTooltip="ngbTooltip"
  >
    <div #shopListRef class="shoplist" data-analytics="my_shop_list">
      <div
        *ngFor="let item of shopsSorted$ | async"
        id="id{{ item.name }}"
        (click)="clickToListShop(item.name)"
        [ngClass]="{ active: item.name === (activeId$ | async) }"
        class="shop"
      >
        <ng-container
          *ngIf="shopTemplateRef"
          [ngTemplateOutlet]="shopTemplateRef"
          [ngTemplateOutletContext]="{ $implicit: item }"
        ></ng-container>
        <!-- ng-content нужен для решения проблемы с задваиванием элементов -->
        <!-- https://github.com/angular/angular/issues/50543#issuecomment-1572900259 -->
        <ng-content />
      </div>
    </div>

    <sd-shops-map
      *ngIf="environmentService.isPlatformBrowser"
      [shops]="shopList"
      [getShopPlacemarkProperties]="getShopPlacemarkProperties"
      class="map-pickup"
      (created)="onMapCreated($event)"
    ></sd-shops-map>
  </div>
</div>
